import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/apikey")({
  component: () => <Navigate to="/dashboard" replace />,
});
